import type { HTMLAttributes } from 'react';
import styles from './Alert.module.css';

export type AlertVariant = 'error' | 'warning' | 'info' | 'success';

export type AlertProps = HTMLAttributes<HTMLDivElement> & {
  variant?: AlertVariant;
};

export function Alert({ variant = 'info', className, children, ...rest }: AlertProps) {
  const classes = [styles.alert, styles[`variant-${variant}`], className].filter(Boolean).join(' ');
  return (
    <div role="alert" className={classes} {...rest}>
      {children}
    </div>
  );
}
